<template>
  <!-- Main -->
  <div id="main">
    <!-- 出單機 -->
    <div id="mainHardware">
      <div class="areaH">
        <div class="areaV">
          <!--<div class="box">
            <div class="item">
              <span class="title">出單機</span>
              <a class="add"><i class="fas fa-plus fa-xs"></i></a>
            </div>
            <table>
              <tr>
                <th><span class="content">狀態</span></th>
                <th><span class="content">ID</span></th>
                <th><span class="content">類型</span></th>
                <th><span class="content">名稱</span></th>
                <th><span class="content">序號</span></th>
                <th><span class="content">密鑰</span></th>
                <th><span class="content">伺服器</span></th>
                <th><span class="content">音量</span></th>
                <th></th>
              </tr>
              <tr class="edit">
                <td></td>
                <td align="center">
                  <input
                    class="input"
                    type="text"
                    placeholder=""
                    style="width: 80px;"
                  />
                </td>
                <td align="center">
                  <div class="dropdown">
                    <select name="type">
                      <option value="出單機">出單機</option>
                      <option value="標籤機">標籤機</option>
                    </select>
                    <div class="arrow">
                      <i class="fas fa-caret-down fa-xs"></i>
                    </div>
                  </div>
                </td>
                <td align="center">
                  <input
                    class="input"
                    type="text"
                    placeholder=""
                    style="width: 80px;"
                  />
                </td>
                <td align="center">
                  <input
                    class="input"
                    type="text"
                    placeholder=""
                    style="width: 80px;"
                  />
                </td>
                <td align="center">
                  <input
                    class="input"
                    type="text"
                    placeholder=""
                    style="width: 80px;"
                  />
                </td>
                <td align="center">
                  <div class="dropdown">
                    <select name="type">
                      <option value="IIOT">IIOT</option>
                    </select>
                    <div class="arrow">
                      <i class="fas fa-caret-down fa-xs"></i>
                    </div>
                  </div>
                </td>
                <td align="center">
                  <div class="dropdown">
                    <select name="type">
                      <option value="大">大</option>
                      <option value="中">中</option>
                      <option value="小">小</option>
                    </select>
                    <div class="arrow">
                      <i class="fas fa-caret-down fa-xs"></i>
                    </div>
                  </div>
                </td>
                <td align="center">
                  <div class="action">
                    <a><i class="fas fa-cog"></i></a>
                    <a><i class="fas fa-unlock"></i></a>
                  </div>
                </td>
              </tr>
              <tr>
                <td align="center">
                  <div class="state on"></div>
                </td>
                <td align="center">
                  <span class="content">1234567890</span>
                </td>
                <td align="center">
                  <span class="content">出單機</span>
                </td>
                <td align="center">
                  <span class="content">快一點餐廳出單機</span>
                </td>
                <td align="center">
                  <span class="content">1234567890</span>
                </td>
                <td align="center">
                  <span class="content">********</span>
                </td>
                <td align="center">
                  <span class="content">IIOT</span>
                </td>
                <td align="center">
                  <span class="content">中</span>
                </td>
                <td align="center">
                  <div class="action">
                    <a><i class="fas fa-cog"></i></a>
                    <a><i class="fas fa-unlock"></i></a>
                  </div>
                </td>
              </tr>
              <tr>
                <td align="center">
                  <div class="state off"></div>
                </td>
                <td align="center">
                  <span class="content">1234567890</span>
                </td>
                <td align="center">
                  <span class="content">標籤機</span>
                </td>
                <td align="center">
                  <span class="content">快一點餐廳出單機</span>
                </td>
                <td align="center">
                  <span class="content">1234567890</span>
                </td>
                <td align="center">
                  <span class="content">********</span>
                </td>
                <td align="center">
                  <span class="content">IIOT</span>
                </td>
                <td align="center">
                  <span class="content">小</span>
                </td>
                <td align="center">
                  <div class="action">
                    <a><i class="fas fa-cog"></i></a>
                    <a><i class="fas fa-unlock"></i></a>
                  </div>
                </td>
              </tr>
            </table>
          </div> -->

          <div class="box">
            <div class="item">
              <span class="title">出單機</span>
              <hover-text text="新增">
                <a class="add" @click="addPrinter()"><FontAwesomeIcon icon="plus"/></a>
              </hover-text>
            </div>
            <table>
              <tr>
                <th><span class="content">狀態</span></th>
                <th><span class="content">ID</span></th>
                <th><span class="content">類型</span></th>
                <th><span class="content">名稱</span></th>
                <th><span class="content">序號</span></th>
                <th><span class="content">密鑰</span></th>
                <th><span class="content">伺服器</span></th>
                <th><span class="content">語言</span></th>
                <th><span class="content">音量</span></th>
                <th></th>
              </tr>
              <tr class="edit" v-show="newPrinter.display">
                <td></td>
                <td></td>
                <td align="center">
                  <div class="dropdown">
                    <select name="type" v-model="newPrinter.printer_type">
                      <option 
                        v-for="(printer_typeOption, index) in printer_typeOptions"
                        :key="'printer_type' + index"
                        :value="printer_typeOption.value"
                        >{{ printer_typeOption.label }}</option
                      >
                    </select>
                    <div class="arrow">
                      <FontAwesomeIcon icon="caret-down" />
                    </div>
                  </div>
                </td>
                <td align="center">
                  <input
                    class="input"
                    type="text"
                    placeholder=""
                    style="width: 80px;"
                    v-model="newPrinter.name"
                  />
                </td>
                <td align="center">
                  <input
                    class="input"
                    type="text"
                    placeholder=""
                    style="width: 80px;"
                    v-model="newPrinter.sn"
                  />
                </td>
                <td align="center">
                  <input
                    class="input"
                    type="text"
                    placeholder=""
                    style="width: 80px;"
                    v-model="newPrinter.secret"
                  />
                </td>
                <td align="center">
                  <div class="dropdown">
                    <select name="type" v-model="newPrinter.server">
                      <option 
                        v-for="(serverOption, index) in serverOptions"
                        :key="'serverOption' + index"
                        :value="serverOption.value"
                        >{{ serverOption.label }}</option
                      >
                    </select>
                    <div class="arrow">
                      <FontAwesomeIcon icon="caret-down" />
                    </div>
                  </div>
                </td>
                <td align="center">
                  <div class="dropdown">
                    <select name="type" v-model="newPrinter.voice_id">
                      <option 
                        v-for="(voice_idOption, index) in voice_idOptions"
                        :key="'voice_idOption' + index"
                        :value="voice_idOption.value"
                        >{{ voice_idOption.label }}</option
                      >
                    </select>
                    <div class="arrow">
                      <FontAwesomeIcon icon="caret-down" />
                    </div>
                  </div>
                </td>
                <td align="center">
                  <div class="dropdown">
                    <select name="type" v-model="newPrinter.volume">
                      <option 
                        v-for="(volumeOption, index) in volumeOptions"
                        :key="'volumeOption' + index"
                        :value="volumeOption.value"
                        >{{ volumeOption.label }}</option
                      >
                    </select>
                    <div class="arrow">
                      <FontAwesomeIcon icon="caret-down" />
                    </div>
                  </div>
                </td>
                <td align="center">
                  <div class="action">
                    <hover-text v-show="!newPrinter.loading" text="儲存">
                      <a @click="saveNewPrinter()"><FontAwesomeIcon icon="save"/></a>
                    </hover-text>
                    <a v-show="newPrinter.loading"><FontAwesomeIcon icon="spinner"/></a>
                    <hover-text text="取消">
                      <a @click="dropNewPrinter()"><FontAwesomeIcon icon="times"/></a>
                    </hover-text>
                  </div>
                </td>
              </tr>

              <tr :class="{ edit: printer.editMode }" 
                v-for="(printer, index) in printers"
                :key="'printer' + index">
                <td align="center">
                  <div class="state on" v-if="printer.is_online"></div>
                  <div class="state off" v-else></div>
                </td>
                <td align="center">
                  <span class="content">{{ printer.did }}</span>
                </td>
                <td align="center">
                  <span class="content" v-show="!printer.editMode">{{ displayPrinterType(printer.printer_type) }}</span>
                  <div class="dropdown" v-show="printer.editMode">
                    <select name="type" v-model="printer.printer_type">
                      <option 
                        v-for="(printer_typeOption, index) in printer_typeOptions"
                        :key="'printer_type' + index"
                        :value="printer_typeOption.value"
                        >{{ printer_typeOption.label }}</option
                      >
                    </select>
                    <div class="arrow">
                      <FontAwesomeIcon icon="caret-down" />
                    </div>
                  </div>
                </td>
                <td align="center">
                  <span class="content" v-show="!printer.editMode">{{ printer.name }}</span>
                  <input
                    class="input"
                    type="text"
                    placeholder=""
                    style="width: 80px;"
                    v-show="printer.editMode"
                    v-model="printer.name"
                  />
                </td>
                <td align="center">
                  <span class="content">{{ printer.sn }}</span>
                </td>
                <td align="center">
                  <span class="content" v-show="!printer.editMode">{{ '*'.repeat(printer.secret.length) }}</span>
                  <span class="content" v-show="printer.editMode">{{ printer.secret }}</span>
                </td>
                <td align="center">
                  <span class="content" v-show="!printer.editMode">{{ displayServer(printer.server) }}</span>
                  <div class="dropdown" v-show="printer.editMode">
                    <select name="type" v-model="printer.server">
                      <option 
                        v-for="(serverOption, index) in serverOptions"
                        :key="'serverOption' + index"
                        :value="serverOption.value"
                        >{{ serverOption.label }}</option
                      >
                    </select>
                    <div class="arrow">
                      <FontAwesomeIcon icon="caret-down" />
                    </div>
                  </div>
                </td>
                <td align="center">
                  <span class="content" v-show="!printer.editMode">{{ displayVoiceId(printer.voice_id) }}</span>
                  <div class="dropdown" v-show="printer.editMode">
                    <select name="type" v-model="printer.voice_id">
                      <option 
                        v-for="(voice_idOption, index) in voice_idOptions"
                        :key="'voice_idOption' + index"
                        :value="voice_idOption.value"
                        >{{ voice_idOption.label }}</option
                      >
                    </select>
                    <div class="arrow">
                      <FontAwesomeIcon icon="caret-down" />
                    </div>
                  </div>
                </td>
                <td align="center">
                  <span class="content" v-show="!printer.editMode">{{ displayVolume(printer.volume) }}</span>
                  <div class="dropdown" v-show="printer.editMode">
                    <select name="type" v-model="printer.volume">
                      <option 
                        v-for="(volumeOption, index) in volumeOptions"
                        :key="'volumeOption' + index"
                        :value="volumeOption.value"
                        >{{ volumeOption.label }}</option
                      >
                    </select>
                    <div class="arrow">
                      <FontAwesomeIcon icon="caret-down" />
                    </div>
                  </div>
                </td>
                <td align="center">
                  <div class="action">
                    <hover-text text="清空列印佇列" v-show="!printer.editMode"><a @click="purgePrinterQueue(index)"><FontAwesomeIcon icon="print"/></a></hover-text>
                    <hover-text text="編輯" v-show="!printer.editMode"><a @click="editPrinter(index)"><FontAwesomeIcon icon="pen"/></a></hover-text>
                    <hover-text text="儲存" v-show="printer.editMode"><a @click="savePrinter(index)"><FontAwesomeIcon icon="save"/></a></hover-text>
                    <hover-text text="刪除" v-show="!printer.editMode"><a @click="deletePrinter(index)"><FontAwesomeIcon icon="trash"/></a></hover-text>
                    <hover-text text="取消" v-show="printer.editMode"><a @click="abandonEditPrinter(index)"><FontAwesomeIcon icon="times"/></a></hover-text>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import HoverText from "src/components/HoverText.vue";
import { fetchPrintersUnderShop } from "src/javascripts/generalPages/fetchForConsoleLog";
import { fetchSettings } from "src/javascripts/generalPages/fetchForConsoleLog";
import { createPrinter } from "src/javascripts/generalPages/postForConsoleLog";
import { 
  deletePrinter as _deletePrinter, 
  purgePrinterQueue as _purgePrinterQueue 
} from "src/javascripts/generalPages/deleteForConsoleLog";
import { updatePrinter } from "src/javascripts/generalPages/updateForConsoleLog";


export default {
  components: {
    FontAwesomeIcon,
    HoverText
  },
  data() {
    return {
      shop: {
        shopId: "",
        shopName: ""
      },
      printers: [],
      printer_typeOptions: [
        {
          value: "PT4G",
          label: "出單機"
        },
        {
          value: "PL4G",
          label: "標籤機"
        },
        {
          value: "PTE",
          label: "出單機"
        }
      ],
      serverOptions: [
        {
          value: "iiot",
          label: "IIOT"
        },
        {
          value: "qc",
          label: "QC"
        },
        {
          value: "qc_v2",
          label: "QC_V2"
        }
      ],
      voice_idOptions: [
        {
          value: 0,
          label: '預設'
        },
        {
          value: 1,
          label: '國語'
        },
        {
          value: 2,
          label: '台語'
        },
        {
          value: 3,
          label: '廣東話'
        }
      ],
      volumeOptions: [
        {
          value: "large",
          label: "人聲大"
        },
        {
          value: "medium",
          label: "人聲中"
        },
        {
          value: "small",
          label: "人聲小"
        },
        {
          value: "didi",
          label: "滴滴聲"
        },
        {
          value: "mute",
          label: "靜音"
        }
      ],
      // 新增出單機預設
      newPrinter: {
        display: false,
        loading: false,
        did: "",
        printer_type: "PT4G",
        name: "",
        sn: "",
        secret: "",
        server: "qc",
        voice_id: 0,
        volume: "large"
      },
      tempPrinter: {
        display: false,
        did: "",
        printer_type: "PT4G",
        name: "",
        sn: "",
        secret: "",
        server: "qc",
        voice_id: 1,
        volume: "large"
      },
      editList: []
    };
  },
  computed: {
    printersIsEditing: function() {
      let index = this.printers.findIndex(printer => printer.editMode);
      return index !== -1 || this.newPrinter.display;
    }
  },
  props: {
    accountId: {
      type: Number,
      default: 1
    },
    value: {
      type: String,
      default: ""
    }
  },
  computed: {
    type() {
      return this.$route.params.type || 'gaa';
    }
  }, 
  created: function() {   
    // initial fetch printers
    fetchSettings(this.accountId, this.$route.params.type)
      .then(settingRes => {
        this.shop.shopId = settingRes.data[0].shop_id;
        this.shop.shopName = settingRes.data[0].name;
        return this.getPrinters();
      });
  },
  methods: {
    getPrinters() {
      console.log('getPrinters')
      return fetchPrintersUnderShop(this.accountId, this.shop, this.type)
        .then(fetchPrintersRes => {
          console.log(fetchPrintersRes);
          this.printers = fetchPrintersRes.data;
          this.printers.forEach(printer => {
            printer.editMode = false;
          })
        })
        .catch(fetchPrintersErr => {
          console.log("fetchPrintersErr: ", fetchPrintersErr);
          this.$message({
            type: "error",
            message: `商店：${this.accountId} ，無法取得出單機資料`
          });
        })
    },
    addPrinter() {
      this.newPrinter.display = true;
    },
    resetNewPrinter() {
      this.newPrinter = Object.assign(this.newPrinter, 
      {
        display: false,
        loading: false,
        did: "",
        printer_type: "PT4G",
        name: "",
        sn: "",
        secret: "",
        server: "qc",
        voice_id: 0,
        volume: "large"
      });
    },
    async saveNewPrinter() {
      let newPrinter = {...this.newPrinter};
      if (this.InvalidInput(newPrinter)) return;
      this.newPrinter.loading = true;
      // 先綁定後更新
      try {
        let createResult = await createPrinter(this.accountId, this.shop, this.addPrinterLog(newPrinter), this.type);
        newPrinter.did = createResult.data.did;
        await this.getPrinters();
        this.resetNewPrinter();
        this.$message({
          type: 'success',
          message: '新增出單機成功'
        });
      } catch(error) {
        console.log(error);
        this.newPrinter.loading = false;
        this.$message({
          type: 'error',
          message: '新增出單機失敗'
        });
      }
    },
    dropNewPrinter() {
      this.resetNewPrinter();
    },
    editPrinter(index) {
      let editModeIndex = this.printers.findIndex(printer => {
        return printer.editMode;
      })
      if (editModeIndex != -1) {
        this.$message({
          type: "warning",
          message: "請先儲存編輯中的設定"
        });
        return;
      }

      this.tempPrinter = {...this.printers[index]};
      this.printers.splice(index, 1, this.printers[index])
      this.printers[index].editMode = true;
    },
    savePrinter(index) {
      updatePrinter(this.accountId, this.shop, this.addPrinterLog(this.printers[index]), this.type)
        .then(updateRes => {
          this.$message({
            type: "success",
            message: "更新出單機設定成功"
          });
          this.printers[index].editMode = false;
          this.printers.splice(index, 1, {...this.printers[index]});
        })
        .catch(updateErr => {
          console.log('updateErr', updateErr);
          this.$message({
            type: "error",
            message: "更新出單機設定失敗"
          });
        });
    },
    abandonEditPrinter(index) {
      this.printers.splice(index, 1, {...this.tempPrinter});
    },
    deletePrinter(index) {
      _deletePrinter(this.accountId, this.shop, this.addPrinterLog(this.printers[index]), this.type)
        .then(unbindRes => {
          this.$message({
            type: 'success',
            message: '刪除出單機成功'
          });
          this.printers.splice(index, 1);
        })
        .catch(unbindErr => {
          console.log('unbindErr', unbindErr);
          this.$message({
            type: 'error',
            message: '刪除出單機失敗'
          });
        })
    },
    purgePrinterQueue(index) {
      _purgePrinterQueue(this.accountId, this.shop, this.addPrinterLog(this.printers[index]), this.type)
        .then(purgeRes => {
          this.$message({
            type: 'success',
            message: '已清除列印佇列'
          });
        })
        .catch(purgeErr => {
          console.log('purgeErr', purgeErr);
          this.$message({
            type: 'error',
            message: '清除列印佇列失敗'
          });
        })
    },
    displayPrinterType(printer_type) {
      if (!printer_type) return '出單機'; // 等 ting 把欄位加上去後可刪掉
      let printerTypeOption = this.printer_typeOptions.find(printer_typeOption => {
        return printer_type === printer_typeOption.value;
      });
      return printerTypeOption ? printerTypeOption.label : '出單機';
    },
    displayServer(server) {
      let serverOption = this.serverOptions.find(serverOption => {
        return server === serverOption.value;
      });
      return serverOption.label;
    },
    displayVoiceId(voice_id) {
      let voice_idOption = this.voice_idOptions.find(voice_idOption => {
        return voice_id === voice_idOption.value;
      });
      return voice_idOption.label;
    },
    displayVolume(volume) {
      let volumeOption = this.volumeOptions.find(volumeOption => {
        return volume === volumeOption.value;
      });
      return volumeOption.label;
    },
    InvalidInput(inputPrinter) {
      // 檢查輸入的出單機設定格式
      for (let printer of this.printers) {
        if (inputPrinter === printer) continue;
        if (inputPrinter.name === printer.name) {
          this.$message({
            type: 'error',
            message: '出單機名稱重複'
          });
          return true;
        }
      }
      if (!inputPrinter.name || !inputPrinter.sn || !inputPrinter.secret) {
        this.$message({
            type: 'error',
            message: '缺少必要欄位'
        });
        return true;
      }
      return false;
    },
    addPrinterLog(printer) {
      let dbTable = 'printers';
      let key = 'setting';
      let label = '出單機設定';
      let type = 'Object';
      let value = '';
      for (let printerKey in printer) {
        switch (printerKey) {
          case 'did': 
            value += `did: ${printer.did}, `;
            break;
          case 'printer_type':
            value += `類型: ${this.displayPrinterType(printer.printer_type)}, `;
            break;
          case 'name':
            value += `名稱: ${printer.name}, `;
            break;
          case 'sn':
            value += `序號: ${printer.sn}, `;
            break;
          case 'secret':
            value += `密鑰: ${printer.secret}`;
            break;
          case 'server':
            value += `伺服器: ${this.displayServer(printer.server)}, `;
            break;
          case 'voice_id':
            value += `語言: ${this.displayVoiceId(printer.voice_id)}, `;
            break;
          case 'volume':
            value += `音量: ${this.displayVolume(printer.volume)}`;
            break;
          default:
            break;
        }
      }
      return { dbTable, key, label, type, value, printer };
    }
  },
  watch: {
    editList: function(newVal, oldVal) {
      console.log("editList newVal: ", newVal);
      if (newVal.length > 0) {
        let editStatusData = {
          value: this.value
        };
        this.$emit("edit-status", editStatusData);
      } else {
        let savedStatusData = {
          value: this.value
        };
        this.$emit("saved-status", savedStatusData);
      }
    },
    printersIsEditing: function(newVal, oldVal) {
      let event = {
        code: 'printers',
        warning: !!newVal,
      };
      let editDataIndex = this.editList.findIndex(d => d.code == event.code);
      if (event.warning) {
        if (editDataIndex == -1) {
          this.editList.push(event);
        } else {
          let editData = this.editList.find(d => d.code == event.code);
          Object.assign(editData, event);
        }
      } else {
        if (editDataIndex != -1) {
          this.editList.splice(editDataIndex, 1);
        }
      }
    }
  }
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css"></style>
